export const PERMISSION_TYPES = {
    READ: 'read',
    ADD: 'add',
    MODIFY: 'modify',
    DELETE: 'delete',
}
export const PERMISSIONS = {

    /*************
     * 
     *  SECTIONS
     * 
     *************/

    panel: {
        user: true,
        admin: true,
        dev: true,
    },

    /*************
     * 
     *  PAGES
     * 
     *************/

    roles: {
        dev: true,
    },
    settings: {
        dev: true,
        admin: true,
    },
    references: {
        dev: true,
        admin: true,
        user: true,
    },
    healthCheck: {
        dev: true,
    },
    newsSources: {
        user: true,
        admin: true,
        dev: true,
    },
    tickets: {
        user: true,
        admin: true,
        dev: true,
    },
    dashboard: {
        user: true,
        admin: true,
        dev: true,
    },
    ads: {
        user: true,
        admin: true,
        dev: true,
    },
    news: {
        user: true,
        admin: true,
        dev: true,
    },
    news_archive: {
        user: true,
        admin: true,
        dev: true,
    },
    forms: {
        user: true,
        admin: true,
        dev: true,
    },
    formsubmissions: {
        user: true,
        admin: true,
        dev: true,
    },
    vreporter: {
        user: true,
        admin: true,
        dev: true,
    },
    comments: {
        user: true,
        admin: true,
        dev: true,
    },
    media: {
        user: true,
        admin: true,
        dev: true,
    },
    services: {
        admin: true,
        dev: true,
    },
    tags: {
        user: true,
        admin: true,
        dev: true,
    },
    links: {
        admin: true,
        dev: true,
    },
    widgets: {
        admin: [PERMISSION_TYPES.READ],
        dev: true,
        system: true,
    },
    users: {
        admin: true,
        dev: true,
    },
    contacts: {
        user: true,
        admin: true,
        dev: true,
    },
    pageData: {
        user: true,
        admin: true,
        dev: true,
    },
    permissions: {
        dev: true,
    },
    support: {
        user: true,
        admin: true,
        dev: true,
    },
    /*************
     * 
     *  products
     * 
     *************/
    products: {
        user: true,
        admin: true,
        dev: true,
    },
    inventory: {
        user: true,
        admin: true,
        dev: true,
    },
    /*************
     * 
     *  MOVIES
     * 
     *************/

    movie: {
        user: true,
        admin: true,
        dev: true,
    },
    people: {
        user: true,
        admin: true,
        dev: true,
    },

    /*************
     * 
     *  ACTIONS
     * 
     *************/

    news_autopublish: {
        user: false,
    },
}
